// rootReducer.js
import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import localStorage from 'redux-persist/lib/storage';
import indexedDBStorage from 'redux-persist-indexeddb-storage';

import drawerReducer from './drawerReducer';
import portfolioReducer from './portfolioReducer';
import portfolioDetailsReducer from './portfolioDetailsReducer';
import notificationReducer from './notificationReducer';
import availableTickersReducer from './availableTickersReducer';
import advisorProfileReducer from './advisorProfileReducer';
import pdfDataReducer from './pdfDataReducer';
import plaidReducer from './plaidReducer';
import optionsReducer from './OptionDataReducer';
import selectionReducer from './selectionReducer';
import pdfSummaryReducer from './pdfSummaryReducer';
import userPictureReducer from './userPictureReducer';
import shieldDataReducer from './shieldDataReducer';
import userSubscriptionReducer from './userSubscriptionReducer';
import optimizerReducer from './optimizerReducer';

import { RESET_STATE } from '../actions/actionTypes';

const tickersPersistConfig = {
  key: 'availableTickers',
  storage: indexedDBStorage('adaptiveDb'),
};

const persistedAvailableTickersReducer = persistReducer(tickersPersistConfig, availableTickersReducer);

const rootPersistConfig = {
  key: 'root',
  storage: localStorage,
  whitelist: ['userPicture', 'userSubscription', 'advisorProfile']
};

const appReducer = combineReducers({
  portfolio: portfolioReducer,
  drawer: drawerReducer,
  portfolioDetails: portfolioDetailsReducer,
  notification: notificationReducer,
  availableTickers: persistedAvailableTickersReducer,
  advisorProfile: advisorProfileReducer,
  pdfData: pdfDataReducer,
  plaid: plaidReducer,
  options: optionsReducer,
  selection: selectionReducer,
  pdfSummary: pdfSummaryReducer,
  userPicture: userPictureReducer,
  shieldData: shieldDataReducer,
  userSubscription: userSubscriptionReducer,
  optimizer: optimizerReducer,
});

const rootReducer = (state, action) => {
  if (action.type === RESET_STATE) {
    const { availableTickers } = state || {};
    state = {
      availableTickers
    };
  }
  return appReducer(state, action);
};

export default persistReducer(rootPersistConfig, rootReducer);
